const actions = {

  ADMINS_READ_BEGIN: 'ADMINS_READ_BEGIN',
  ADMINS_READ_SUCCESS: 'ADMINS_READ_SUCCESS',
  ADMINS_READ_ERR: 'ADMINS_READ_ERR',

  ADMIN_ADD_BEGIN: 'ADMIN_ADD_BEGIN',
  ADMIN_ADD_SUCCESS: 'ADMIN_ADD_SUCCESS',
  ADMIN_ADD_ERR: 'ADMIN_ADD_ERR',

  ADMIN_UPDATE_BEGIN: 'ADMIN_UPDATE_BEGIN',
  ADMIN_UPDATE_SUCCESS: 'ADMIN_UPDATE_SUCCESS',
  ADMIN_UPDATE_ERR: 'ADMIN_UPDATE_ERR',

  ADMIN_DELETE_BEGIN: 'ADMIN_DELETE_BEGIN',
  ADMIN_DELETE_SUCCESS: 'ADMIN_DELETE_SUCCESS',
  ADMIN_DELETE_ERR: 'ADMIN_DELETE_ERR',

  ADMIN_READ_BEGIN: 'ADMIN_READ_BEGIN',
  ADMIN_READ_SUCCESS: 'ADMIN_READ_SUCCESS',
  ADMIN_READ_ERR: 'ADMIN_READ_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.ADMINS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.ADMINS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.ADMINS_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.ADMIN_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.ADMIN_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.ADMIN_ADD_ERR,
      err,
    };
  },
  axiosUpdateBegin: () => {
    return {
      type: actions.ADMIN_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.ADMIN_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.ADMIN_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.ADMIN_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.ADMIN_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.ADMIN_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.ADMIN_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.ADMIN_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.ADMIN_READ_ERR,
      err,
    };
  },

};

export default actions;
